import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class OfflineDataService {

    getData(id: string, pageId?: string): any {

        const offlineData = window.window['offlineData'];
        if (pageId) {
            return offlineData[this.getDataByIdentifier(id)][pageId];
        }

        return offlineData[this.getDataByIdentifier(id)];
    }

    getOfflineData(): any {
        return window.window['offlineData'];
    }

    private getDataByIdentifier(id: string): any {

        const allEndpoints = environment.endpointUrls;
        let propertyName;

        Object.keys(allEndpoints).forEach(prop => {
            if (allEndpoints[prop] === id) {
                propertyName = prop;
            }
        });

        return propertyName;
    }
}
